import { render, staticRenderFns } from "./AutoResponseIndex.vue?vue&type=template&id=5a938e58&scoped=true&"
import script from "./AutoResponseIndex.vue?vue&type=script&lang=js&"
export * from "./AutoResponseIndex.vue?vue&type=script&lang=js&"
import style0 from "./AutoResponseIndex.vue?vue&type=style&index=0&id=5a938e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a938e58",
  null
  
)

export default component.exports